"use strict";
var isObject = require("../internals/is-object");
var classof = require("../internals/classof-raw");
var wellKnownSymbol = require("../internals/well-known-symbol");
var MATCH = wellKnownSymbol("match");
module.exports = function(it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== void 0 ? !!isRegExp : classof(it) === "RegExp");
};
